<svg
  width="110"
  height="142"
  viewBox="0 0 110 142"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class="text-foreground"
>
  <path
    d="M50.6852 4.74874L76.9542 8.66164C83.6411 9.65769 88.6164 10.3995 92.4438 11.4004C96.262 12.3989 98.8796 13.6419 100.879 15.6044C102.189 16.8909 103.289 18.3756 104.138 20.0041C105.432 22.4883 105.858 25.3546 105.701 29.298C105.543 33.2509 104.802 38.2265 103.806 44.9133L93.157 116.407C92.3819 121.61 91.8058 125.473 91.0292 128.443C90.255 131.403 89.2949 133.418 87.7877 134.953C86.7952 135.964 85.6499 136.813 84.3936 137.467C82.4857 138.462 80.2784 138.793 77.2208 138.671C74.1537 138.548 70.2908 137.973 65.0875 137.198L31.697 132.225C25.0101 131.229 20.0348 130.487 16.2074 129.486C12.3892 128.487 9.77156 127.244 7.77253 125.282C6.46211 123.995 5.36235 122.511 4.51362 120.882C3.21889 118.398 2.79283 115.532 2.95044 111.588C3.10842 107.635 3.84886 102.66 4.8449 95.973L14.4335 31.6008C15.4295 24.9139 16.1713 19.9386 17.1722 16.1113C18.1708 12.2931 19.4137 9.67539 21.3762 7.67636C22.6627 6.36595 24.1474 5.26618 25.7759 4.41745C28.2601 3.12272 31.1264 2.69666 35.0699 2.85427C39.0228 3.01225 43.9983 3.75269 50.6852 4.74874Z"
    stroke="currentColor"
  />
  <rect
    x="21.8413"
    y="4.00366"
    width="88.1673"
    height="126.064"
    rx="15.4679"
    transform="rotate(8.4722 21.8413 4.00366)"
    fill="currentColor"
  />
  <mask
    id="mask0_34_29"
    style="mask-type:alpha"
    maskUnits="userSpaceOnUse"
    x="5"
    y="6"
    width="102"
    height="134"
  >
    <rect
      x="22.0205"
      y="4.7269"
      width="87.1673"
      height="125.064"
      rx="13.5"
      transform="rotate(8.4722 22.0205 4.7269)"
      fill="currentColor"
      stroke="currentColor"
    />
  </mask>
  <g mask="url(#mask0_34_29)">
    <path
      d="M80.4215 52.3991C80.5085 52.0948 80.9535 52.1421 80.9746 52.4578V52.4578C81.0144 53.0519 81.4226 53.5572 81.995 53.7209V53.7209C82.2993 53.8079 82.252 54.2529 81.9362 54.2741V54.2741C81.3421 54.3138 80.8369 54.722 80.6732 55.2945V55.2945C80.5862 55.5987 80.1411 55.5514 80.12 55.2357V55.2357C80.0803 54.6416 79.6721 54.1363 79.0996 53.9726V53.9726C78.7953 53.8856 78.8426 53.4406 79.1584 53.4195V53.4195C79.7525 53.3797 80.2578 52.9715 80.4215 52.3991V52.3991Z"
      fill="#F7F5F2"
    />
    <path
      d="M43.8788 89.588C44.0136 89.1167 44.7028 89.19 44.7355 89.679V89.679C44.797 90.5991 45.4292 91.3816 46.3158 91.6351V91.6351C46.787 91.7698 46.7137 92.459 46.2247 92.4917V92.4917C45.3047 92.5533 44.5222 93.1854 44.2686 94.072V94.072C44.1339 94.5432 43.4447 94.47 43.412 93.981V93.981C43.3505 93.0609 42.7183 92.2784 41.8317 92.0249V92.0249C41.3605 91.8901 41.4337 91.2009 41.9228 91.1682V91.1682C42.8428 91.1067 43.6253 90.4745 43.8788 89.588V89.588Z"
      fill="#F7F5F2"
    />
    <path
      d="M47.5444 125.328C47.7118 124.743 48.5679 124.834 48.6085 125.441L48.7875 128.118C48.864 129.261 49.6492 130.233 50.7505 130.548L53.3299 131.286C53.9153 131.453 53.8243 132.309 53.2168 132.35L50.54 132.529C49.3971 132.605 48.4251 133.391 48.1102 134.492L47.3726 137.071C47.2052 137.657 46.349 137.566 46.3084 136.958L46.1294 134.281C46.053 133.139 45.2677 132.166 44.1664 131.852L41.587 131.114C41.0016 130.947 41.0926 130.09 41.7001 130.05L44.3769 129.871C45.5198 129.794 46.4918 129.009 46.8068 127.908L47.5444 125.328Z"
      fill="#F7F5F2"
    />
    <path
      d="M13.934 68.2762C14.0848 67.7489 14.856 67.8309 14.8926 68.3781V68.3781C14.9614 69.4076 15.6688 70.2833 16.6609 70.567V70.567C17.1882 70.7177 17.1063 71.489 16.559 71.5256V71.5256C15.5295 71.5944 14.6539 72.3018 14.3702 73.2939V73.2939C14.2194 73.8212 13.4482 73.7392 13.4116 73.192V73.192C13.3427 72.1625 12.6353 71.2868 11.6433 71.0031V71.0031C11.116 70.8524 11.1979 70.0811 11.7451 70.0445V70.0445C12.7747 69.9757 13.6503 69.2683 13.934 68.2762V68.2762Z"
      fill="#F7F5F2"
    />
    <path
      d="M35.0813 35.9191C35.2487 35.3337 36.1126 35.4255 36.1532 36.033V36.033C36.2296 37.1759 37.0293 38.1656 38.1306 38.4806V38.4806C38.7159 38.648 38.6241 39.5119 38.0166 39.5525V39.5525C36.8738 39.6289 35.884 40.4285 35.569 41.5298V41.5298C35.4016 42.1152 34.5377 42.0234 34.4971 41.4159V41.4159C34.4207 40.273 33.6211 39.2832 32.5198 38.9683V38.9683C31.9344 38.8009 32.0262 37.937 32.6337 37.8964V37.8964C33.7766 37.82 34.7664 37.0203 35.0813 35.9191V35.9191Z"
      fill="#F7F5F2"
    />
    <circle
      cx="18.667"
      cy="105.322"
      r="1.95153"
      transform="rotate(6.06626 18.667 105.322)"
      fill="#F7F5F2"
    />
    <circle
      cx="70.1094"
      cy="91.3"
      r="1.52086"
      transform="rotate(6.06626 70.1094 91.3)"
      fill="#F7F5F2"
    />
    <circle
      cx="56.1746"
      cy="62.4036"
      r="0.913953"
      transform="rotate(6.06626 56.1746 62.4036)"
      fill="#F7F5F2"
    />
    <path
      d="M102.057 58.4565C102.184 58.9299 102.874 58.868 102.915 58.3796V58.3796C102.992 57.4607 103.637 56.6887 104.527 56.4498V56.4498C105.001 56.3229 104.939 55.6326 104.45 55.5918V55.5918C103.532 55.5151 102.76 54.8701 102.521 53.9795V53.9795C102.394 53.5061 101.703 53.568 101.663 54.0564V54.0564C101.586 54.9753 100.941 55.7473 100.05 55.9862V55.9862C99.577 56.1131 99.6389 56.8035 100.127 56.8442V56.8442C101.046 56.9209 101.818 57.5659 102.057 58.4565V58.4565Z"
      fill="#F7F5F2"
    />
    <path
      d="M95.6185 24.5282C95.7762 25.1163 96.6337 25.0394 96.6843 24.4327L96.6948 24.3076C96.79 23.1661 97.5912 22.2072 98.6976 21.9104L98.8188 21.8779C99.4069 21.7202 99.33 20.8627 98.7233 20.812L98.5982 20.8016C97.4567 20.7063 96.4978 19.9051 96.201 18.7988L96.1685 18.6775C96.0108 18.0895 95.1533 18.1663 95.1026 18.7731L95.0922 18.8982C94.9969 20.0396 94.1957 20.9986 93.0894 21.2954L92.9681 21.3279C92.3801 21.4856 92.4569 22.3431 93.0637 22.3937L93.1888 22.4042C94.3302 22.4994 95.2892 23.3007 95.5859 24.407L95.6185 24.5282Z"
      fill="#F7F5F2"
    />
    <path
      d="M86.7897 118.061C86.9318 118.59 87.7042 118.521 87.7499 117.975V117.975C87.8357 116.946 88.5574 116.083 89.554 115.815V115.815C90.0837 115.673 90.0145 114.901 89.4679 114.855V114.855C88.4397 114.769 87.5758 114.048 87.3085 113.051V113.051C87.1665 112.521 86.394 112.59 86.3484 113.137V113.137C86.2626 114.165 85.5408 115.029 84.5442 115.296V115.296C84.0145 115.439 84.0838 116.211 84.6303 116.257V116.257C85.6585 116.342 86.5224 117.064 86.7897 118.061V118.061Z"
      fill="#F7F5F2"
    />
    <circle
      cx="1.95153"
      cy="1.95153"
      r="1.95153"
      transform="matrix(0.996007 -0.0892741 -0.0892741 -0.996007 63.8359 31.9253)"
      fill="#F7F5F2"
    />
  </g>
</svg>
